import { makeRequest } from "#app/api/chat";
export { makeRequest };
